// Popover or Modal target componentKey for targets in CMS rich text content,
// which is not in the component map: "resolve within the same rich text value".
export const CMS_RICH_TEXT_OVERLAY_TARGET_SCOPE = 'cms-rich-text';
